import axios from 'axios';

const CHUNK_SIZE = 20 * 1024 * 1024; // 20MB
const PARALLEL = 1;

// export async function uploadMultipleFiles(files, userId, onProgress) {

//     const totalSize = files.reduce((sum, f) => sum + f.size, 0);
//     const uploadedMap = new Map(); // ファイルごとのアップロード済みバイト数

//     const uploads = files.map(file => {
//         const formData = new FormData();
//         formData.append("files", file);
//         formData.append("user_id", userId);

//         uploadedMap.set(file.name, 0); // 初期値

//         return axios.post(
//             process.env.REACT_APP_CHUNK_UPLOAD_URL,
//             formData,
//             {
//                 withCredentials: true,
//                 headers: { "X-Requested-With": "XMLHttpRequest" },
//                 onUploadProgress: (e) => {
//                     uploadedMap.set(file.name, e.loaded);

//                     // 全ファイルのアップロード済み合計
//                     const uploadedTotal = Array.from(uploadedMap.values())
//                         .reduce((sum, val) => sum + val, 0);

//                     const percent = Math.round((uploadedTotal * 100) / totalSize);

//                     if (onProgress) onProgress(percent);
//                 }
//             }
//         );
//     });

//     const results = await Promise.all(uploads);
//     return results.map(r => r.data);
// }



/* 1ファイル分割並列アップロード */





export async function uploadMultipleFiles(files, userId, onProgress, audioParams) {

    if (!Array.isArray(files)) files = [files];

    const results = [];

    for (const file of files) {

        if (!file || !file.size) throw new Error("Invalid file");

        const uploadId = crypto.randomUUID();

        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        const lastChunkIndex = totalChunks - 1;

        const chunkProgress = new Array(totalChunks).fill(0);

        let nextIndex = 0;

        function updateProgress(i, percent) {

            chunkProgress[i] = percent;

            const total =
                chunkProgress.reduce((a, b) => a + b, 0) / totalChunks;

            if (onProgress) {
                onProgress(Math.round(total * 100));
            }
        }

        async function sendChunk(i) {

            const start = i * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);

            const chunk = file.slice(start, end);

            const formData = new FormData();

            formData.append("chunk", chunk);
            formData.append("user_id", userId);
            formData.append("filename", file.name);
            formData.append("chunk_index", i);
            formData.append("total_chunks", totalChunks);
            formData.append("upload_id", uploadId);
            formData.append(
                "audio_params",
                JSON.stringify({
                    VOCAL_GAIN_BIAS_DB: audioParams.VOCAL_GAIN_BIAS_DB,
                    THRESHOLD_DB: audioParams.THRESHOLD_DB,
                    RATIO: audioParams.RATIO,
                    ATTACK_MS: audioParams.ATTACK_MS,
                    RELEASE_MS: audioParams.RELEASE_MS,
                    EQ: [
                        audioParams.EQ_UI.bass,
                        audioParams.EQ_UI.treble
                    ]
                })
            );
            const res = await axios.post(
                process.env.REACT_APP_CHUNK_UPLOAD_URL,
                formData,
                {
                    withCredentials: true,
                    onUploadProgress: (e) => {

                        if (!e.total) return;

                        updateProgress(i, e.loaded / e.total);
                    }
                }
            );

            return res.data;
        }

        async function worker() {

            while (true) {

                const i = nextIndex;

                if (i >= lastChunkIndex) break;

                nextIndex += 1;

                await sendChunk(i);
            }
        }

        // 並列アップロード (最後以外)
        await Promise.all(
            Array(PARALLEL).fill(0).map(worker)
        );

        // 最後のchunkは単独送信
        const result = await sendChunk(lastChunkIndex);

        results.push(result);
    }

    return results;
}